<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>How the Senate Snapshot is Determined</h1>
      <p>My Senate SnapShot gauge is based on the most recent poll for each contested Senate seat from FiveThirtyEight “B-” or better rated pollsters.</p>
      <p>This gauge shows the expected number of Democratic Senators seated in the next Senate if the November election goes as the most recent polling suggests it would if the election were held today. The gauge value shows:
      <ul>
        <li>the number of Senate seats the Democrats currently hold that are not up for election this year, PLUS</li>
        <li>the numbers of races in which they are leading by 3 or more points in the latest polling, PLUS</li>
        <li>one-half of the number of seats that I’ve currently rated at Too Close to Call (polls showing candidates with less than 3 points of each other).</li>
      </ul>
      </p>
      <p>My assumption for SnapShot is that each side will win half of the races that are Too Close to Call.</p>
      <p>The lighter blue region on both sides fo the needle shows the potential range of Democratic seats if the seats that are currently Too Close to Call go either all to the Republicans or all to the Democrats.
      "Democratic seats" on the gauge include as "Democrats" the Senate's two independents Angus King (ME) and Bernie Sanders (VT) both of whom caucus with the Democrats.
      </p>
     <p>
       The gauge needle shows a minimum of 40 Democratic seats, which would give the Republicans a 60 vote super majority, and maximum of 60 Democratic seats, which would give the Democrats a super majority. (Neither outcome is on the horizon this election, but 2022 will be interesting since Republicans will then have to defend 22 seats, while Democrats will only need to defend 12.)</p>

     <h2> Senate Races to Watch</h2>
<p style="background-color: yellow;">[NOTE: These poll numbers are outdated. I’ll update them soon and remove this comment] – SMV 7.26.20]</p>
<p>
<ul>
   <li>   Republican seats currently trending Democratic (6)</li>
   <li>   Arizona (D: Kelly +4 over R: (incumbent McSally)</li>
   <li>   Colorado (D: Hickenlooper +11 over R: (incumbent Gardner)</li>
   <li>   Georgia (special election) D: Collins +6 over R: (incumbent Loeffler)</li>
   <li>   Maine (D: Gideon +4 over R: (incumbent Collins)</li>
   <li>   North Carolina (D: Cunninham +8 over R: (incumbent Tillis)</li>
   <li>   Republican seats that are Too Close to Call (4)</li>
   <li>   Kansas (D: Bollier +1 over R: Hamilton, +1 over R: Kobach, -1 behind R: Marshall)</li>
   <li>   Iowa (Greenfield +2 over R: (incumbent) Ernst)</li>
  <li>    South Carolina (R:(incumbent) Graham tied w/ D:Harrison)</li>
  <li>    Montana (R (incumbent) Daines) +2 over D: Bullock)</li>
  <li>    Republican Seats w/in reach of Democrats (1)</li>
     <li> Georgia (R: Perdue +3 over D: Ossoff)</li>
     <li> Democratic seats trending Republican (1)</li>
     <li> Alabama (R: Tuberville +8 over D: (incumbent) Jones)</li>
      </ul>
</p>
<br/>
<br/>
<br/>
      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutSenateControl",
  components: {
    DashHeader
  }
};
</script>
